<ng-container *ngIf="!is_redirected_user">
<div class="container-fluid grey-bg pink-bg form-wrapper sign-in-wrapper">

    <div class="row">
        <div class="col-12">
            <div class="form-box">
                <div class="top-detail">
                    <a href="/" title="Back to Home"><img alt="world of sweets logo"
                            src="../../assets/images/bonds-logo-footer.svg" /></a>
                    <h1>Sign in to Your Account</h1>
                    <p>If you have an account, sign in with your email address.</p>
                </div>

                <form [formGroup]="loginForm" (ngSubmit)="login()" autocomplete="off">
                    <div class="form-group">
                        <label>Email address <sup>*</sup></label>
                        <input type="email" maxLength="100"  autocomplete="doNotAutoComplete" class="form-control email" formControlName="email"
                            placeholder="E.g. mert.ryder@gmail.com">
                        <div *ngIf="submitted && loginForm.controls.email.errors" class="error">
                            <div *ngIf="loginForm.controls.email.errors.required"><img src="assets/images/error.svg" />
                                Email is required</div>
                            <div *ngIf="loginForm.controls.email.errors.email"><img src="assets/images/error.svg" />
                                Email must be a valid email address</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Password <sup>*</sup></label>
                        <input [type]="fieldTextType ? 'text' : 'password'" class="form-control password"
                            formControlName="password" autocomplete="doNotAutoComplete" placeholder="Your Password">
                        <div class="input-group-append">
                            <i [ngClass]="{
                                'fa-eye-slash': !fieldTextType,
                                'fa-eye': fieldTextType
                              }" (click)="toggleFieldTextType()"></i>
                        </div>
                        <div *ngIf="submitted && loginForm.controls.password.errors" class="error">
                            <div *ngIf="loginForm.controls.password.errors.required"><img
                                    src="assets/images/error.svg" /> Password is required</div>
                        </div>
                        <div class="error media-error" *ngIf="submitted && !loginForm.controls.password.errors">
                            {{errMessage}} </div>
                    </div>
                    <div class="forgot-password">
                        <a routerLink="/users/forgot-password" title="Forgot Password">Forgot Password?</a>
                    </div>
                    <button type="submit" class="btn primary-btn">Sign In</button>
                </form>
                <div class="redirect-signup">
                    <p>Already a World of Sweets Retailer? Use the sign up to get your login. <a routerLink="/users/sign-up" title="Sign Up">Sign Up</a></p>
                </div>
            </div>

        </div>
    </div>
    <img class="lemon-image" src="../../assets/images/lemon.png" alt="lemon">
</div>
<div class="container-fluid form-wrapper reseller grey-color">
    <div class="row">
        <div class="col-12">
                <ul class="blue-box">
                    <li>

                        <p>Not a World of Sweets Reseller ? <br> Want a Call</p>
                        <a class="btn primary-btn" routerLink="/contact-us">Contact Us</a>
                    </li>

                </ul>
        </div>
    </div>
</div>

<div class="slider-wrapper pt-0">
    <testimonial-slider></testimonial-slider>
   <app-footer></app-footer>
</div>
</ng-container>

<ng-container *ngIf="is_redirected_user">

    <div>
        <app-default-redirection-screen
        [heading_message]="heading_message"
        [paragraph_message]="paragraph_message"
        [is_signed_differen_user]="is_signed_differen_user"
        (emitLogoutEvent)="logoutHandler()"
        (emitCancelEvent)="cancelHandler()"
        [has_cancelled]="has_cancelled"
        (emitOkayEvent)="onOkayHandler()"
        >
    </app-default-redirection-screen>
    </div>

</ng-container>
